<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="samples">
    <div class="w overflow-hidden">
      <Row class="samples-content overflow-hidden">
        <Col
          v-for="(item, index) in samples"
          :key="item.id"
          span="12"
          class="h-full content"
          @click.native="link(item.link)"
        >
          <div
            class="samples-content-box w-full h-full cursor-pointer relative overflow-hidden"
            :data-id="String.fromCharCode(64 + parseInt(index + 1))"
            :style="{
              'background-color': colors[index] ? colors[index]['bgc'] : ''
            }"
          >
            <!-- <div class="sample-bg absolute">
              {{ String.fromCharCode(64 + parseInt(index + 1)) }}
            </div> -->
            <div class="sample-title align-middle clearfix">
              <span
                class="bar inline-block text-center float-left"
                :style="{
                  'background-color': colors[index] ? colors[index].bar : ''
                }"
                >{{ index + 1 }}</span
              >
              <span class="inline-block title"> {{ item.title }}</span>
            </div>
            <div class="sample-detail relative">{{ item.content }}</div>
            <div class="sample-nums relative icon1">
              样本数量：{{ item.sample_num }}
            </div>
            <div class="sample-nums relative icon2">
              样本类型：{{ item.sample_type }}
            </div>
            <div class="sample-nums relative icon3">
              疾病数量：{{ item.diseases_num }}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'samplesComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      samples: [
        {
          id: '1',
          title: '北京大学附属医院A生物样本库',
          content:
            '北京大学附属医院干细胞库始建于1996年，现已初步形成标准化、规范化的样本采集、储存和管理体系。目前收集了近20000份样本，现有-80℃冰箱15台、液氮罐3个。',
          sample_num: '20000',
          sample_type: '细胞、胎盘、头发、血浆、血清、器官组织',
          diseases_num: 223,
          link: 'sampleA',
          image: '/static/images/background/sample2.png'
        },
        {
          id: '2',
          title: '北京大学附属医院B生物样本库',
          content:
            '北京大学附属医院生物样本库始建于1992年，现已初步形成标准化、规范化的样本采集、储存和管理体系。目前收集了近5000份样本，现有-80℃冰箱6台，液氮罐1个。',
          sample_num: '5000',
          sample_type: '细胞、胎盘、头发、血浆、血清',
          diseases_num: 112,
          link: 'waiting',
          image: '/static/images/background/sample3.png'
        },
        {
          id: '3',
          title: '北京大学附属医院C人体组织库',
          content:
            '北京大学附属医院生物样本库始建于1993年，现已初步形成标准化、规范化的样本采集、储存和管理体系。目前收集了近50000份样本，现有-80℃冰箱30台，液氮罐6个',
          sample_num: '50000',
          sample_type: '细胞、胎盘、头发、血浆、血清、器官组织',
          diseases_num: 345,
          link: 'waiting',
          image: '/static/images/background/sample4.png'
        },
        {
          id: '4',
          title: '疾控中心基因标本库',
          content:
            '疾控中心基因标本库始建于2005年，现已初步形成标准化、规范化的样本采集、储存和管理体系。目前收集了近30000份样本，现有-80℃冰箱20台，液氮罐6个',
          sample_num: '30000',
          sample_type: '细胞、胎盘、头发、血浆、血清',
          diseases_num: 112,
          link: 'waiting',
          image: '/static/images/background/sample5.png'
        },
        {
          id: '5',
          title: '北京大学附属医院肿瘤样本库',
          content:
            '北京大学附属医院肿瘤样本库始建于2007年，现已初步形成标准化、规范化的样本采集、储存和管理体系。目前收集了近40000份样本，现有-80℃冰箱40台，液氮罐1个',
          sample_num: '40000',
          sample_type: '细胞、胎盘、头发、血浆、血清、器官组织',
          diseases_num: 235,
          link: 'waiting',
          image: '/static/images/background/sample6.png'
        }
      ],
      colors: [
        {
          bgc: '#46BFB814',
          bar: '#53CBC4',
          fc: '#3AABA5'
        },
        {
          bgc: '#468CBF14',
          bar: '#53A0CB',
          fc: '#3AABA5'
        },
        {
          bgc: '#A7BF4614',
          bar: '#B1BF81',
          fc: '#3AABA5'
        },
        {
          bgc: '#BF464614',
          bar: '#E09494',
          fc: '#3AABA5'
        },
        {
          bgc: '#69C6C214',
          bar: '#79C1BD',
          fc: '#3AABA5'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  methods: {
    link(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.samples {
  background-color: $c-white;
  padding-bottom: 2.08vw; //40px;
  padding-top: 3.125vw; //60px;

  .content {
    padding-right: 1.72vw; //33px;
    padding-bottom: 1.61vw; //31px;
    height: 19.375vw; //372px;
    &:nth-child(2n) {
      padding-right: 0;
    }
  }
  .samples-content-box {
    padding: 3.59vw 3.59vw 0 4.48vw; //69px 69px 0 86px;
    border-radius: 0.73vw; //14px;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      .sample-title .title {
        color: #3aaba5;
      }
    }
    &:after {
      content: attr(data-id);
      font-size: 19.27vw; //370px;
      line-height: 1;
      letter-spacing: 4px;
      color: $c-white;
      opacity: 0.4;
      // float: right;
      // margin-top: -210px;
      // margin-right: -50px;
      z-index: 0;
      position: absolute;
      bottom: -6.51vw; //-125px;
      right: 0;
    }
  }
  .sample-title {
    font-size: 1.46vw; //28px;

    color: #111a2e;
    margin-bottom: 1.72vw; //33px;
    .bar {
      width: 1.67vw; //32px;
      height: 1.67vw; //32px;
      line-height: 1.67vw; //32px;
      color: $c-white;
      border-radius: 4px;
      font-size: 0.94vw; //18px;
      margin-right: 12px;
      margin-top: 4px;
    }
  }
  .sample-detail,
  .sample-nums {
    font-size: 0.83vw; //16px;
    line-height: 1.37;
    letter-spacing: 1px;
    color: #646a77;
    padding-bottom: 0.94vw; //18px;
    padding-left: 1.3vw; //25px;
    z-index: 1;
    &:before {
      content: '';
      width: 0.83vw; //16px;
      height: 0.83vw; //16px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;
      position: absolute;
      top: 3px;
      left: 0;
    }
  }
  .sample-detail:before {
    background-image: url('/static/images/icons/detail.png');
  }

  .sample-nums {
    color: #303849;
    padding-bottom: 0.42vw; //8px;
  }
  .sample-nums.icon1:before {
    background-image: url('/static/images/icons/sampleNum.png');
  }
  .sample-nums.icon2:before {
    background-image: url('/static/images/icons/sampleType.png');
  }
  .sample-nums.icon3:before {
    background-image: url('/static/images/icons/diseasesNum.png');
  }
  .sample-bg {
    font-size: 19.27vw; //370px;
    line-height: 1;
    letter-spacing: 4px;
    color: $c-white;
    opacity: 0.4;
    bottom: -6.51vw; //-125px;
    right: 0;
    z-index: 0;
  }
}
</style>
